import { inject,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Injectable,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import * as d3 from "d3";
import { axisTickFormat } from '../chart-axis-format';
import { FilterService } from 'src/app/services/filter.service';
import { CurrencyPipe } from '@angular/common';
import { NoDataNotifierService } from 'src/app/services/no-data-notifier.service';

@Injectable({
  providedIn: 'root'
})
@Component({
    selector: 'app-grouped-hbar-chart',
    templateUrl: './grouped-hbar-chart.component.html',
    styleUrls: ['./grouped-hbar-chart.component.scss'],
    standalone: false
})
export class GroupedHbarChartComponent implements OnInit, OnChanges {
  private readonly noDataNotifier = inject(NoDataNotifierService);

  @ViewChild('barContainer', { static: true }) barContainer!: ElementRef;
  @ViewChild('WordCloudChart') WordCloudChart!: ElementRef;
  @ViewChild('fs') fs!: ElementRef;
  @Input('data') data: any;
  @Input('pageKey') pageKey: any;
  @Input('item') item: any;
  @Input('config') config: any;
  @Input('headerConfig') headerConfig: any;
  @Input('error_name') error_name: any;
  @Input('heading') heading: string = '';
  @Input('prefrenceConfig') prefrenceConfig: any;
  @HostBinding('class.is-fullscreen') isFullscreen = false;

  isActive = false;
  mytooltipData: any;
  iconList: any[] = [];
  GroupedHbarChartData: any = [];
  props: any;
  divId: any = "GroupedHbarChartDiv";
  initiateChart: Boolean = false;
  dataTurn: any;
  isTooltip: boolean = false;
  noData: boolean = false;
  myType: any;

  private handleRadius = 6;
  private currentMin = 0;
  private currentMax = 100;
  private margins = { left: 10, top: 20 };
  private orientation = 'horizontal';

  height: any = 0;

  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    if (!document.fullscreenElement) {
      this.isTooltip = false;
      this.closeFullscreen();
    }
  }

  constructor(
    private filterService: FilterService,
    private currency: CurrencyPipe
  ) {
    this.filterService.filterQuery.subscribe((query: any) => {
      this.start();
    });
  }

  // loader
  isLoading = false;
  async stop(ms: number): Promise<void> {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  }
  start() { this.isLoading = true; }

  private showTooltip(myType: any, myData: any, myX: any, myY: any, chartWidth: any, chartHeight: any): void {
    this.myType = myType;
    this.mytooltipData = myData;
    this.height = 0;
    this.dataTurn = 0;
    this.height = chartHeight - myY;
    this.dataTurn = chartWidth - myX;

    if (this.isFullscreen == true) {
      if (myType == 'groupFullName') {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('top', (myY + 45) + 'px')
          .style('left', (myX + 20) + 'px')
          .style('right', 'unset');
      } else if (this.height < 200) {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('bottom', (this.height - 60) + 'px')
          .style('top', 'unset');
      } else if (this.height > 200) {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('top', (myY + 30) + 'px')
          .style('bottom', 'unset');
      }

      if (this.dataTurn < 250) {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('right', (this.dataTurn + 20) + 'px')
          .style('left', 'unset');
      } else if (this.dataTurn > 250) {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('left', (myX + 25) + 'px')
          .style('right', 'unset');
      }
      this.isTooltip = true;
    } else {
      if (myType == 'groupFullName') {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('top', (myY + 45) + 'px')
          .style('left', (myX + 20) + 'px')
          .style('right', 'unset');
      } else if (this.height < 200) {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('bottom', (this.height - 60) + 'px')
          .style('top', 'unset');
      } else if (this.height > 200) {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('top', (myY + 30) + 'px')
          .style('bottom', 'unset');
      }

      if (this.dataTurn < 250) {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('right', (this.dataTurn + 20) + 'px')
          .style('left', 'unset');
      } else if (this.dataTurn > 250) {
        d3.select("#d3HBarTooltip")
          .style('visibility', 'visible')
          .style('position', 'absolute')
          .style('left', (myX + 25) + 'px')
          .style('right', 'unset');
      }

      this.isTooltip = true;
    }
  }

  private hideTooltip(myType: any): void {
    this.isTooltip = false;
    // d3.select("#d3HBarTooltip").style('visibility', 'hidden');
  }

  ngOnInit(): void {
    this.start();
    this.iconList = this.item.config.icon ? this.item.config.icon : this.iconList;
    this.initiateCharts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] &&
        changes['data'].currentValue !== changes['data'].previousValue &&
        this.initiateChart) {
      this.getGroupedHbarChartData();
    }

    // If preferences change later
    if (changes['prefrenceConfig'] &&
        changes['prefrenceConfig'].currentValue !== changes['prefrenceConfig'].previousValue &&
        this.GroupedHbarChartData?.length) {
      this.applyChartPreferences(changes['prefrenceConfig'].currentValue);
    }
  }

  closeFullscreen(): void {
    this.isFullscreen = false;
    if (document.fullscreenElement) {
      this.isTooltip = false;
      document.exitFullscreen();
    }
    this.props.chartHeight = 500;
    this.isActive = false;
    setTimeout(() => {
      this.plotChart();
    }, 100);
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    setTimeout(() => {
      this.plotChart();
    }, 100);
  }

  // d3 chart initial structure
  initiateCharts(): void {
    const myChart = this;
    const myClass = myChart.divId;

    const mySvg = d3.select('#' + myClass)
      .append('svg')
      .attr('id', 'svg_' + myClass)
      .attr('width', '100%')
      .style('background-color', 'white');

    mySvg.append('g').attr('id', 'legendGroup' + myClass);
    mySvg.append('g').attr('id', 'brushBarGroup' + myClass);
    mySvg.append("g").attr("id", "brushGroup" + myClass);
    mySvg.append("g").attr("id", "xAxis" + myClass);
    mySvg.append('text').attr('id', 'xAxisLabel' + myClass);
    mySvg.append('text').attr('id', 'yAxisLabel' + myClass);
    mySvg.append('text').attr('id', 'noDataMessage' + myClass);

    const defs = mySvg.append('defs');

    defs.append('clipPath').attr('id', 'ghbBrushClip' + myClass)
      .append('rect').attr('id', 'ghbBrushClipRect' + myClass);

    defs.append('clipPath').attr('id', 'ghbtextClip' + myClass)
      .append('rect').attr('id', 'ghbtextClipRect' + myClass);

    defs.append('clipPath').attr('id', 'alcClip' + myClass)
      .append('rect').attr('id', 'alcClipRect' + myClass);

    const filter = defs.append('filter').attr('id', 'drop-shadow').attr('width', 10).attr('height', 24);
    filter.append('feGaussianBlur').attr('in', 'SourceAlpha').attr('stdDeviation', 1).attr('result', 'blur');
    filter.append('feOffset').attr('in', 'blur').attr('dx', 1)
      .attr('dy', 1).attr('result', 'offsetBlur');
    filter.append('feFlood').attr('in', 'offsetBlur')
      .attr('flood-color', '#000000').attr('flood-opacity', 0.4)
      .attr('result', 'offsetColor');
    filter.append('feComposite').attr('in', 'offsetColor').attr('in2', 'offsetBlur').attr('operator', 'in').attr('result', 'offsetBlur');
    const feMerge = filter.append('feMerge');
    feMerge.append('feMergeNode').attr('in', 'offsetBlur');
    feMerge.append('feMergeNode').attr('in', 'SourceGraphic');

    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleLeftLine1' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleLeftLine2' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleRightLine1' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleRightLine2' + myClass);
    mySvg.append('g').attr('id', 'sliderGroup' + myClass).attr('class', 'slider' + myClass);

    this.initiateChart = true;
  }

  // chart svg  plotChart rendering
  plotChart(): void {
    const myChart: any = this;
    const myClass = myChart.divId;
    const mySvg: any = d3.select('#svg_' + myClass);
    const width: any = mySvg.node().getBoundingClientRect().width;
    let height = myChart.props.chartHeight < 300 ? 300 : myChart.props.chartHeight;

    const margins = { left: 20, right: 20, top: 40, bottom: 40, group: 4, brush: 52, mid: 24, range: 52 };

    mySvg.attr("height", height);
   margins.bottom = myChart.props.xAxisShow ? margins.bottom : 10;
   margins.range = myChart.props.yAxisShow ? margins.range : 0;
   margins.mid = myChart.props.yAxisShow ? margins.mid : 0;
   margins.top = myChart.props.legendShow ? margins.top : 10;

    // Bar Slider
    myChart.barMin = undefined;
    myChart.barMax = undefined;
    // Line Slider
    myChart.lineMin = undefined;
    myChart.lineMax = undefined;

    let rangeSet: any = new Set();
    let stackSet: any = Object.keys(myChart.props.barFill);
    let groupSet: any = new Set();

    myChart.GroupedHbarChartData.forEach((d: any) => {
      rangeSet.add(d[myChart.props.rangeVar]);
      groupSet.add(d[myChart.props.groupVar]);
    });

    stackSet = Array.from(stackSet);
    rangeSet = Array.from(rangeSet);
    groupSet = Array.from(groupSet);

    const firstGroup = Array.from(d3.group(myChart.GroupedHbarChartData, (d: any) => d[myChart.props.groupVar]));
    const stackData: any = [];
    firstGroup.forEach((d: any) => {
      rangeSet.forEach((r: any) => {
        const myStackObject: any = {
          groupVar: d[0],
          range: r,
        };
        const matchingRows: any = d[1].filter((f: any) => f[myChart.props.groupVar] === d[0] && f[myChart.props.rangeVar] === r);
        stackSet.forEach((s: any) => {
          const myRange = matchingRows.filter((f: any) => f[myChart.props.stackVar] === s);
          if (myRange === undefined) {
            myStackObject[s] = 0;
          } else {
            myStackObject[s] = d3.sum(myRange, (s: any) => s[myChart.props.valueVar]);
          }
        });
        stackData.push(myStackObject);
      });
    });

    const myStack = d3.stack()
      .keys(stackSet)
      .order(d3.stackOrderNone)
      .offset(d3.stackOffsetNone)
      (stackData);

    const allStack: any = [];
    myStack.forEach((d: any) => d.forEach((s: any) => {
      s["key"] = d.key;
      allStack.push(s);
    }));

    let groupedData: any = [];
    let xMax: any = d3.max(allStack, (m: any) => m[1]);

    groupSet.forEach((d: any, i: any) => {
      const myData = allStack.filter((f: any) => f.data.groupVar === d);
      let groupTotal = 0;
      myData.forEach((segment: any) => {
        groupTotal += (segment[1] - segment[0]);
      });

      const byRange: any = [];
      rangeSet.forEach((r: any) => {
        const rangeData = myData.filter((f: any) => f.data.range === r);
        let rangeTotal = 0;
        rangeData.forEach((segment: any) => {
          rangeTotal += (segment[1] - segment[0]);
        });

        const rangeWithPercentages = rangeData.map((segment: any) => {
          const segmentValue = segment[1] - segment[0];
          const percentage = rangeTotal > 0 ? (segmentValue / rangeTotal) * 100 : 0;
          return {
            ...segment,
            percentage: percentage,
            segmentValue: segmentValue,
            groupIndex: i,
            rangeIndex: rangeSet.indexOf(r),
            totalValue: rangeTotal
          };
        });

        byRange.push({
          range: r,
          rangeWithPercentages,
          rangeTotal: rangeTotal,
          groupIndex: i,
          rangeIndex: rangeSet.indexOf(r),
          totalValue: rangeTotal
        });
      });

      groupedData.push({
        group: d,
        data: byRange,
        groupIndex: i,
        maxVal: d3.max(myData, (m: any) => m[1]),
        totalValue: groupTotal
      });
    });

    let visibleGroups = 1;
    const chartWidth = width - margins.left - margins.brush - margins.mid - margins.range - 36 - 24 - margins.right;
    let groupHeight = (22 * (rangeSet.length + 1)) + margins.group;
    let chartHeight = (groupHeight * groupSet.length) + margins.top + margins.bottom;

    xMax = myChart.props.totalOntop ? (xMax * 1.1) : xMax;

    const yScaleAll: any = d3.scaleLinear().domain([0, groupSet.length]).range([0, height - margins.top - margins.bottom]);
    const yScale: any = d3.scaleLinear().domain([0, groupSet.length]).range([0, height - margins.top - margins.bottom]);
    const xScale: any = d3.scaleLinear().domain([0, xMax]).range([0, chartWidth]);
    const xScaleBrush: any = d3.scaleLinear().domain([0, xMax]).range([0, margins.brush - 2]);

    const brushRangeHeight = ((height - margins.top - margins.bottom) / groupSet.length) / (rangeSet.length + 2);
    let startingVisibleGroups: any = parseInt(String((height - margins.top - margins.bottom) / groupHeight));
    startingVisibleGroups = startingVisibleGroups > groupSet.length ? groupSet.length : startingVisibleGroups;
    const brushStartY = groupSet.length === 0 ? 0 : (1 - (startingVisibleGroups / groupSet.length))
      * (height - margins.top - margins.bottom);
    groupHeight = (height - margins.top - margins.bottom) / startingVisibleGroups;
    let rangeHeight = (groupHeight * visibleGroups) / (rangeSet.length + 2);

    const brush: any = d3.brushY()
      .handleSize(10)
      .extent([[0, 0], [margins.brush, height - margins.top - margins.bottom]])
      .on('start brush end', brushed);

    // INITIAL X AXIS (respects preferences)
    renderXAxis(xScale);

    mySvg.select('#ghbBrushClipRect' + myClass)
      .style('width', width - margins.left - margins.right - margins.brush - margins.mid)
      .style('height', height - margins.top - margins.bottom)
      .attr('transform', 'translate(' + (margins.left + margins.brush + margins.mid) + ',' + margins.top + ')');

    mySvg.select('#ghbtextClipRect' + myClass)
      .style('width', chartWidth)
      .style('height', height - margins.top - margins.bottom);

    mySvg.select('#alcClipRect' + myClass)
      .style('width', margins.brush)
      .style('height', height - margins.top - margins.bottom);

    mySvg.selectAll('.brushChartGroup' + myClass).remove();

    const brushGroup = mySvg
      .select('#brushGroup' + myClass)
      .attr('clip-path', 'url(#alcClip' + myClass + ')')
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');

    const brushChartGroup = brushGroup
      .selectAll('.brushChartGroup' + myClass)
      .data(groupedData)
      .join((enter: any) => {
        const groupEnter = enter.append('g').attr('class', 'brushChartGroup' + myClass);
        groupEnter.append('g').attr('class', 'brushRangeGroup');
        return groupEnter;
      });

    brushChartGroup
      .select('.brushRangeGroup')
      .attr('transform', (d: any) => `translate(0, ${yScale(d.groupIndex) + 10})`);

    const brushRangeGroup = brushChartGroup
      .select('.brushRangeGroup')
      .selectAll('.brushRangeGroup' + myClass)
      .data((d: any) => d.data)
      .join((group: any) => {
        const enter = group.append('g').attr('class', '.brushRangeGroup' + myClass);
        enter.append('g').attr('class', 'BrushrangeBarGroup');
        return enter;
      });

    brushRangeGroup.select(".BrushrangeBarGroup")
      .attr("transform", (d: any, i: any) => "translate(0 ," + ((i * brushRangeHeight) - 3) + ")");

    const BrushrangeBarGroup = brushRangeGroup.select(".BrushrangeBarGroup")
      .selectAll('.BrushrangeBarGroup' + myClass)
      .data((d: any) => {
        d.rangeWithPercentages.map((m: any, i: any) => {
          const dataWidth = xScaleBrush(m[1]) - xScaleBrush(m[0]);
          m.width = dataWidth < 2 && dataWidth !== 0 ? 2 : dataWidth;
          if (dataWidth < 2 && i < (d.rangeWithPercentages.length - 1)) {
            d.rangeWithPercentages.filter((f: any, index: any) => index > i).forEach((m: any) => {
              m.extraX = dataWidth === 0 ? 0 : 2 - dataWidth;
            });
          }
        });

        d.rangeWithPercentages.map((m: any, i: any) => m.borderRadius = i === (d.rangeWithPercentages.length - 1) ? 0 : 0);
        return d.rangeWithPercentages;
      })
      .join((enter: any) => {
        const barEnter = enter.append('g').attr('class', 'BrushrangeBarGroup' + myClass);
        barEnter.append('path').attr('class', 'brushRangeBar');
        return barEnter;
      });

    BrushrangeBarGroup
      .select('.brushRangeBar')
      .attr('d', (d: any) => {
        const { width, borderRadius } = d;
        return `
          M0,0 
          L${width - borderRadius},0 
          Q${width},0 ${width},${borderRadius} 
          L${width},${brushRangeHeight - borderRadius} 
          Q${width},${brushRangeHeight} ${width - borderRadius},${brushRangeHeight} 
          L0,${brushRangeHeight} Z
        `;
      })
      .attr("transform", (d: any) =>
        "translate(" + (xScaleBrush(d[0]) + (d.extraX === undefined ? 0 : d.extraX)) + ",0.5)")
      .attr('fill', (d: any) => myChart.props.barFill[d.key]);

    mySvg.select('#brushGroup' + myClass)
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')')
      .call(brush)
      .call(brush.move, [0, (height - margins.top - margins.bottom) - brushStartY]);

    mySvg.selectAll('.handleLines' + myClass)
      .attr('visibility', myChart.GroupedHbarChartData.length === 0 ? 'hidden' : 'visible')
      .attr('x1', margins.left + (margins.brush - 12) / 2)
      .attr('x2', margins.left + 12 + (margins.brush - 12) / 2)
      .style('stroke', '#8A98AB')
      .style('stroke-width', '1')
      .attr('transform', 'translate(0,' + margins.top + ')');

    // AXIS LABELS (respect preferences)
    mySvg.select('#xAxisLabel' + myClass)
      .attr('visibility', myChart.props.xAxisShow ? 'visible' : 'hidden')
      .attr('x', margins.left + ((width - margins.left - margins.right) / 2))
      .attr('y', height)
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Poppins')
      .attr('fill', '#737D88')
      .attr('font-size', '12px')
      .text(myChart.props.xAxisLabel);

    mySvg.select('#yAxisLabel' + myClass)
      .attr('visibility', myChart.props.yAxisShow ? 'visible' : 'hidden')
      .attr('transform', 'translate(10,' + (margins.top + ((height - margins.top - margins.bottom - margins.mid - margins.brush) / 2)) + ') rotate(-90)')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Poppins')
      .attr('fill', '#737D88')
      .attr('font-size', '12px')
      .text(myChart.props.yAxisLabel);

    mySvg.selectAll('#brushGroup' + myClass)
      .selectAll('.selection')
      .attr('fill', '#A0A0A0')
      .attr('fill-opacity', '0.09')
      .style('stroke', '#E8EAEE')
      .style('stroke-width', '1');

    drawLegend(Object.keys(myChart.props.barFill));
    drawChart();

    function drawChart() {
      const xScale: any = d3.scaleLinear().domain([myChart.barMin || 0, myChart.barMax || xMax]).range([0, chartWidth]);
      const xScaleBrush: any = d3.scaleLinear().domain([myChart.barMin || 0, myChart.barMax || xMax]).range([0, margins.brush - 2]);

      renderXAxis(xScale);

      const BrushrangeBarGroup = brushRangeGroup.select(".BrushrangeBarGroup")
        .selectAll('.BrushrangeBarGroup' + myClass)
        .data((d: any) => {
          d.rangeWithPercentages.map((m: any, i: any) => {
            const dataWidth = xScaleBrush(m[1]) - xScaleBrush(m[0]);
            m.width = dataWidth < 2 && dataWidth !== 0 ? 2 : dataWidth;
            if (dataWidth < 2 && i < (d.rangeWithPercentages.length - 1)) {
              d.rangeWithPercentages.filter((f: any, index: any) => index > i).forEach((m: any) => {
                m.extraX = dataWidth === 0 ? 0 : 2 - dataWidth;
              });
            }
          });

          d.rangeWithPercentages.map((m: any, i: any) => m.borderRadius = i === (d.rangeWithPercentages.length - 1) ? 0 : 0);
          return d.rangeWithPercentages;
        })
        .join((enter: any) => {
          const barEnter = enter.append('g').attr('class', 'BrushrangeBarGroup' + myClass);
          barEnter.append('path').attr('class', 'brushRangeBar');
          return barEnter;
        });

      BrushrangeBarGroup
        .select('.brushRangeBar')
        .attr('d', (d: any) => {
          const { width, borderRadius } = d;
          return `
            M0,0 
            L${width - borderRadius},0 
            Q${width},0 ${width},${borderRadius} 
            L${width},${brushRangeHeight - borderRadius} 
            Q${width},${brushRangeHeight} ${width - borderRadius},${brushRangeHeight} 
            L0,${brushRangeHeight} Z
          `;
        })
        .attr("transform", (d: any) =>
          "translate(" + (xScaleBrush(d[0]) + (d.extraX === undefined ? 0 : d.extraX)) + ",0.5)")
        .attr('fill', (d: any) => myChart.props.barFill[d.key]);

      groupHeight = (height - margins.top - margins.bottom) / visibleGroups;
      rangeHeight = groupHeight / (rangeSet.length + 2);

      mySvg.selectAll('#brushGroup' + myClass)
        .selectAll('.selection')
        .attr('fill', '#A0A0A0')
        .attr('fill-opacity', '0.09')
        .style('stroke', '#E8EAEE')
        .style('stroke-width', '1');

      mySvg.selectAll(".selection")
        .attr('visibility', myChart.GroupedHbarChartData.length === 0 ? 'hidden' : 'visible');

      const chartGroup = mySvg
        .selectAll('.chartGroup' + myClass)
        .data(groupedData)
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'chartGroup' + myClass);
          enter.append('rect').attr('class', 'groupRect');
          enter.append('line').attr('class', 'groupTopLine');
          enter.append('line').attr('class', 'groupBottomLine');
          enter.append('text').attr('class', 'groupLabel');
          enter.append('g').attr('class', 'rangeGroup');
          return enter;
        });

      chartGroup.attr('clip-path', 'url(#ghbBrushClip' + myClass + ')');

      chartGroup.select('.groupLabel')
      .attr('visibility', myChart.props.yAxisShow ? 'visible' : 'hidden')  
        .attr("font-family", "Poppins")
        .attr("font-weight", 700)
        .attr("font-size", 12)
        .attr("fill", "white")
        .attr('text-anchor', 'middle')
        .attr('transform', (d: any) => 'translate('
          + (margins.left + margins.brush + margins.mid + 18 + 5)
          + ',' + (yScale(d.groupIndex) + margins.top + (groupHeight - margins.group) / 2) + ') rotate(-90)')
        .text(getGroupLabel)
        .on("mouseover", (event: any, d: any) => {
          if (getGroupLabel(d).includes("..")) {
            myChart.showTooltip('groupFullName', d.group.toUpperCase(), event.offsetX, event.offsetY, width, height);
          }
        })
        .on("mouseout", () => {
          myChart.hideTooltip("groupFullName");
        });

      chartGroup.select('.groupTopLine')
      .attr('visibility', myChart.props.yAxisShow ? 'visible' : 'hidden')  
        .style('stroke-width', 1)
        .style('stroke', '#E8EAEE')
        .attr('x1', margins.left + margins.brush + margins.mid + 36 + margins.range + 10)
        .attr('x2', margins.left + margins.brush + margins.mid + 36)
        .attr('y1', (d: any) => yScale(d.groupIndex) + margins.top)
        .attr('y2', (d: any) => yScale(d.groupIndex) + margins.top);

      chartGroup.select('.groupBottomLine')
      .attr('visibility', myChart.props.yAxisShow ? 'visible' : 'hidden')  
        .style('stroke-width', 1)
        .style('stroke', '#E8EAEE')
        .attr('x1', margins.left + margins.brush + margins.mid + 36 + margins.range + 10)
        .attr('x2', margins.left + margins.brush + margins.mid + 36)
        .attr('y1', (d: any) => yScale(d.groupIndex) + margins.top + (groupHeight - margins.group))
        .attr('y2', (d: any) => yScale(d.groupIndex) + margins.top + (groupHeight - margins.group));

      chartGroup.select('.groupRect')
      .attr('visibility', myChart.props.yAxisShow ? 'visible' : 'hidden')  
        .style('width', 36)
        .style('height', groupHeight - margins.group)
        .style('fill', '#8A98AB')
        .attr('transform', (d: any) => 'translate(' + (margins.left + margins.brush + margins.mid) + ',' + (yScale(d.groupIndex) + margins.top) + ')');

      chartGroup.select('.rangeGroup')
        .attr('transform', (d: any) => 'translate(' + (margins.left + margins.brush + margins.mid + 36) + ',' + (yScale(d.groupIndex)
          + margins.top + rangeHeight) + ')');

      const rangeGroup = chartGroup
        .select('.rangeGroup')
        .selectAll('.rangeGroup' + myClass)
        .data((d: any) => d.data)
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'rangeGroup' + myClass);
          enter.append('text').attr('class', 'rangeLabel');
          enter.append('g').attr('class', 'rangeBarGroup');
          enter.append('rect').attr('class', 'rangeMouseoverRect');
          return enter;
        });

      rangeGroup.select(".rangeMouseoverRect")
        .attr("fill", "transparent")
        .attr("width", (d: any) => xScale(d3.max(d.rangeWithPercentages, (m: any) => m[1])))
        .attr("height", rangeHeight)
        .attr('x', margins.range + 24)
        .attr('y', (d: any, i: any) => (i * rangeHeight))
        .on("mouseover", (event: any, d: any) => {
          const tooltipData: any = [];
          d.rangeWithPercentages.forEach((t: any) => {
            tooltipData.push({
              group: t.data.groupVar,
              range: d.range,
              key: t.key,
              value: t.data[t.key]
            });
          });
          myChart.showTooltip('groupHBar', tooltipData, event.offsetX, event.offsetY, width, height);
        })
        .on('mouseout', () => {
          myChart.hideTooltip('groupHBar');
        });

      rangeGroup.select(".rangeLabel")
      .attr('visibility', myChart.props.yAxisShow ? 'visible' : 'hidden')  
        .attr("font-family", "Poppins")
        .attr("font-size", myChart.props.yAxisFontSize)
        .attr("font-weight", myChart.props.yAxisBold ? 700 : 400)
        .attr("fill", myChart.props.yAxisColor)
        .attr('text-anchor', 'end')
        .attr('x', margins.range)
        .attr('y', (d: any, i: any) => (i * rangeHeight) + (rangeHeight / 2) + 5)
        .text((d: any) => d.range);

      rangeGroup.select(".rangeBarGroup").attr('clip-path', 'url(#ghbtextClip' + myClass + ')')
        .attr("transform", (d: any, i: any) => "translate(" + (margins.range + 24) + "," + (i * rangeHeight) + ")");

      const rangeBarGroup = rangeGroup.select(".rangeBarGroup")
        .selectAll('.rangeBarGroup' + myClass)
        .data((d: any) => {
          d.rangeWithPercentages.map((m: any, i: any) => {
            const dataWidth = xScale(m[1]) - xScale(m[0]);
            m.width = dataWidth < 2 && dataWidth !== 0 ? 2 : dataWidth;
            if (dataWidth < 2 && i < (d.rangeWithPercentages.length - 1)) {
              d.rangeWithPercentages.filter((f: any, index: any) => index > i)
                .forEach((m: any) => {
                  m.extraX = dataWidth === 0 ? 0 : 2 - dataWidth;
                });
            }
          });

          d.rangeWithPercentages.map((m: any, i: any) =>
            m.borderRadius = i === (d.rangeWithPercentages.length - 1) ? 2 : 0
          );

          return d.rangeWithPercentages;
        })
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'rangeBarGroup' + myClass);
          enter.append('path').attr('class', 'rangeBar');
          enter.append('text').attr('class', 'rangeBarPercentageText');
          mySvg.select('#sliderGroup' + myClass).raise();
          return enter;
        });

      /*********** VALUE ON BAR (with preferences) ***********/
      rangeBarGroup.selectAll('.valueOnBarGroup').remove()
      if (myChart.props.valueOnBar) {

        const valueOnBarGroup = rangeBarGroup
          .selectAll('.valueOnBarGroup')
          .data((d: any) => [d])
          .join(
            (enter: any) => enter.append("g").attr("class", "valueOnBarGroup"),
            (update: any) => update,
            (exit: any) => exit.remove()
          );

        function formatValue(d: any) {
          const type = myChart.props.valueOnBarType;
          const dp = myChart.props.valueOnBardecimalPlaces ?? 0;
          const units = myChart.props.valueOnBarDisplayUnits || "Auto";
          const v = type === "value" ? d.segmentValue : d.percentage;

          if (type === "percentage") {
            return v.toFixed(dp) + "%";
          }

          let val = v;
          if (units === "None") return val.toFixed(dp);
          if (units === "K") return (val / 1e3).toFixed(dp) + "K";
          if (units === "M") return (val / 1e6).toFixed(dp) + "M";
          if (units === "B") return (val / 1e9).toFixed(dp) + "B";

          if (Math.abs(val) >= 1e9) return (val / 1e9).toFixed(dp) + "B";
          if (Math.abs(val) >= 1e6) return (val / 1e6).toFixed(dp) + "M";
          if (Math.abs(val) >= 1e3) return (val / 1e3).toFixed(dp) + "K";
          return val.toFixed(dp);
        }

        valueOnBarGroup.each(function (d: any) {
          //@ts-ignore
        const g = d3.select(this);
        const textValue = formatValue(d);

        const segmentStart = xScale(d[0]);
        const segmentEnd = xScale(d[1]);
        const segmentWidth = segmentEnd - segmentStart;

        g.selectAll("text").remove();
        g.selectAll("rect").remove();

        const fontSize = 10;
        const textWidth = measure(textValue, fontSize, "Poppins", 400);
        const textHeight = fontSize + 4;

        // --- HIDE BASED ON BAR SIZE ---
        const minWidth = 10;
        const minHeight = 12;

        if (
          !textValue ||
          segmentWidth < minWidth ||
          rangeHeight < minHeight ||
          textWidth + 6 > segmentWidth ||  // text cannot fit
          textHeight > rangeHeight          // text height exceeds bar
        ) {
          return;
        }

        // Continue drawing text...
        const textX = segmentStart + segmentWidth / 2;
        let textY = (rangeHeight / 2) + 4;

        if (myChart.props.valueOnBarposition === "top") textY = -6;
        if (myChart.props.valueOnBarposition === "bottom") textY = rangeHeight + 11;

        if (myChart.props.valueOnBarBackground) {
          g.append("rect")
            .attr("x", textX - (textWidth / 2) - 3)
            .attr("y", textY - fontSize + 2)
            .attr("width", textWidth + 6)
            .attr("height", textHeight)
            .attr("fill", myChart.props.valueOnBarBackgroundColor || "#000")
            .attr("rx", 2)
            .attr("ry", 2);
        }

        g.append("text")
          .attr("x", textX)
          .attr("y", textY)
          .attr("fill", myChart.props.valueOnBarColor || "white")
          .attr("text-anchor", "middle")
          .attr("dominant-baseline", "middle")
          .attr("font-size", fontSize)
          .attr("font-family", "Poppins")
          .attr("font-weight", 400)
          .text(textValue);
      });

      }

      rangeBarGroup.select(".rangeBar")
        .attr("d", (d: any) =>
          "M0,0 L" +
          (d.width - d.borderRadius) + ",0 Q" + d.width + ",0 " + d.width + "," + d.borderRadius +
          " L " + d.width + "," + (rangeHeight - d.borderRadius + 5) +
          " Q " + d.width + "," + (rangeHeight + 5) + " " + (d.width - d.borderRadius) + "," + (rangeHeight + 5) +
          " L 0," + (rangeHeight + 5) + " Z"
        )
        .attr("transform", (d: any) =>
          "translate(" + (xScale(d[0]) + (d.extraX === undefined ? 0 : d.extraX)) + ",0)"
        )
        .attr("fill", (d: any) => myChart.props.barFill[d.key]);

      /*********** TOTAL ON TOP (with preferences) ***********/
      // Cleared before the flag is checked: .rangeGroup persists across renders (join
      // update selection), so without this the labels of a previous render survive when
      // the preference is switched off or reset to its default.
      rangeGroup.selectAll('.groupTotalGroup').remove()
      if (myChart.props.totalOntop) {

        const totalGroup = rangeGroup
          .selectAll(".groupTotalGroup")
          .data((d: any) => [d])
          .join(
            (enter: any) => enter.append("g").attr("class", "groupTotalGroup"),
            (update: any) => update,
            (exit: any) => exit.remove()
          );

        function formatTotal(d: any) {
          const dp = myChart.props.decimalPlaces ?? 0;
          const units = myChart.props.displayUnits || "Auto";
          let val = d.rangeTotal;

          if (units === "None") return val.toFixed(dp);
          if (units === "K") return (val / 1e3).toFixed(dp) + "K";
          if (units === "M") return (val / 1e6).toFixed(dp) + "M";
          if (units === "B") return (val / 1e9).toFixed(dp) + "B";

          if (Math.abs(val) >= 1e9) return (val / 1e9).toFixed(dp) + "B";
          if (Math.abs(val) >= 1e6) return (val / 1e6).toFixed(dp) + "M";
          if (Math.abs(val) >= 1e3) return (val / 1e3).toFixed(dp) + "K";
          return val.toFixed(dp);
        }

        totalGroup.each(function (d: any,i:any) {
          //@ts-ignore
          const g = d3.select(this);
          const textValue = formatTotal(d);
          g.selectAll("text").remove();
          g.selectAll("rect").remove();

          // IMPORTANT: Local coordinates inside rangeBarGroup
          const totalX = margins.range+margins.mid+xScale(d.rangeTotal) + 6; // small padding inside bar axis
          const totalY = (d.rangeIndex * rangeHeight) + (rangeHeight / 2) + 5; // center of bar height (local)
          

          const fontSize = myChart.props.totalLabelFontSize ?? 12;
          const fontWeight = myChart.props.totalLabelBold ? 700 : 400;
          const textWidth = measure(textValue, fontSize, "Poppins", fontWeight);

          if (myChart.props.totalOnTopBackground && textValue!=0) {
            g.append("rect")
              .attr("x", totalX -3 )
              .attr("y", totalY - fontSize / 2 - 3)
              .attr("width", textWidth + 6)
              .attr("height", fontSize + 4)
              .attr("fill", myChart.props.totalOnTopBackgroundColor || "#fff")
              .attr("rx", 2)
              .attr("ry", 2);
          }

          g.append("text")
            .attr("x", totalX)
            .attr("y", totalY)
            .attr("fill", myChart.props.totalOnTopColor || "#101D42")
            .attr("font-size", fontSize)
            .attr("font-family", "Poppins")
            .attr("font-weight", fontWeight)
            .attr("text-anchor", "start")
            .attr("dominant-baseline", "middle")
            .text(textValue==0?'':textValue);
        });

      }

      function measure(text: string, size: number, family: string, weight: number) {
        const c = document.createElement("canvas");
        const ctx = c.getContext("2d");
        if (!ctx) return 0;
        ctx.font = `${weight} ${size}px ${family}`;
        return ctx.measureText(text).width;
      }
    }

    mySvg.select('#sliderGroup' + myClass).remove();
    const slider = mySvg.append('g').attr('id', 'sliderGroup' + myClass);

    // Bar Slider
    if (myChart.props.leftSlider) {
      myChart.barMin = myChart.currentMin;
      myChart.barMax = xMax;
      createRangeSlider('bar', myChart.currentMin, xMax);
    }

    function createRangeSlider(id: string, min: number, max: number): void {
      const sliderGroupId = `sliderGroup-${id}`;
      const sliderClass = `${id}-slider`;

      slider.select(`#${sliderGroupId}`).remove();
      const sliderGroup = slider.append('g').attr('id', sliderGroupId);

      const scale = d3
        .scaleLinear()
        .domain([min, max])
        .range(
          myChart.orientation === 'horizontal'
            ? [0, xScale.range()[1]]
            : [yScale.range()[0], 0]
        )
        .clamp(true);

      const transformValue = `translate(${margins.left + margins.right + margins.brush + margins.range + margins.mid + 40}, ${
        height - margins.bottom
      })`;

      const dragMinHandle = d3
        .drag()
        .on('drag', (event) =>
          onDragMinHandle(sliderGroup, event, scale, sliderClass, id, min, max)
        );
      const dragMaxHandle = d3
        .drag()
        .on('drag', (event) =>
          onDragMaxHandle(sliderGroup, event, scale, sliderClass, id, min, max)
        );

      sliderGroup
        .append('line')
        .attr('class', `${sliderClass} ${id}-track`)
        .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
        .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max))
        .attr('transform', transformValue)
        .attr('stroke', '#ddd')
        .attr('stroke-width', 1);

      sliderGroup
        .append('line')
        .attr('class', `${sliderClass} ${id}-track-inset`)
        .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
        .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max))
        .attr('transform', transformValue)
        .attr('stroke', '#ddd')
        .attr('stroke-width', 1);

      const tooltip = d3
        .select('body')
        .append('div')
        .attr('class', 'tooltip')
        .style('position', 'absolute')
        .style('padding', '5px')
        .style('background', '#fff')
        .style('border', '1px solid #ccc')
        .style('border-radius', '4px')
        .style('pointer-events', 'none')
        .style('opacity', 0);

      createSliderHandle(
        sliderGroup,
        sliderClass,
        id,
        'min',
        min,
        scale,
        dragMinHandle,
        tooltip,
        transformValue
      );
      createSliderHandle(
        sliderGroup,
        sliderClass,
        id,
        'max',
        max,
        scale,
        dragMaxHandle,
        tooltip,
        transformValue
      );
    }

    function createSliderHandle(
      sliderGroup: any,
      sliderClass: string,
      id: string,
      handleType: string,
      value: number,
      scale: any,
      dragHandle: any,
      tooltip: any,
      transformValue: string
    ): void {
      const circleColor: string = handleType === 'min' ? '#718EB6' : '#69b3a2';

      const hoverLayer = sliderGroup
        .append('circle')
        .attr('class', `${sliderClass} ${id}-${handleType}-hover-layer`)
        .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
        .attr('transform', transformValue)
        .attr('r', myChart.handleRadius + 8)
        .attr('fill', circleColor)
        .attr('opacity', 0)
        .attr('pointer-events', 'none');

      const handle = sliderGroup
        .append('circle')
        .attr('class', `${sliderClass} ${id}-${handleType}-handle`)
        .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
        .attr('transform', transformValue)
        .attr('r', myChart.handleRadius)
        .attr('fill', circleColor)
        .on('mousedown', function () {
          handle.raise();
        })
        .call(dragHandle);

      handle
        .on('mouseover', function () {
          hoverLayer.transition().duration(200).attr('opacity', 0.4);
        })
        .on('mouseout', function () {
          hoverLayer.transition().duration(400).attr('opacity', 0);
        });
    }

    const Xposition = margins.left + margins.right + margins.brush + margins.range + margins.mid + 40;

    function onDragMinHandle(
      sliderGroup: any,
      event: any,
      scale: any,
      sliderClass: string,
      id: string,
      min: number,
      max: number
    ): void {

      const newPos = Math.max(scale(min), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - (Xposition));
      const currentMin = Math.round(scale.invert(newPos));

      if (currentMin >= min && currentMin <= (id === 'line' ? myChart.lineMax - 5 : myChart.barMax - 5)) {
        id === 'line' ? myChart.lineMin = currentMin : myChart.barMin = currentMin;
        updateSliderHandlePosition(sliderGroup, sliderClass, id, 'min', newPos);
        updateTrackInset(sliderGroup, scale, sliderClass, id, currentMin, max);
        drawChart();
      } else if (currentMin < min) {
        id === 'line' ? myChart.lineMin = min : myChart.barMin = min;
        updateSliderHandlePosition(sliderGroup, sliderClass, id, 'min', scale(min));
        updateTrackInset(sliderGroup, scale, sliderClass, id, min, max);
        drawChart();
      }
    }

    function onDragMaxHandle(
      sliderGroup: any,
      event: any,
      scale: any,
      sliderClass: string,
      id: string,
      min: number,
      max: number
    ): void {
      const newPos = Math.min(scale(max), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - (Xposition));
      const currentMax = Math.round(scale.invert(newPos));

      if (currentMax <= max && currentMax >= (id === 'line' ? myChart.lineMin + 5 : myChart.barMin + 5)) {
        id === 'line' ? myChart.lineMax = currentMax : myChart.barMax = currentMax;
        updateSliderHandlePosition(sliderGroup, sliderClass, id, 'max', newPos);
        updateTrackInset(sliderGroup, scale, sliderClass, id, min, currentMax);
        drawChart();
      } else if (currentMax > max) {
        id === 'line' ? myChart.lineMax = max : myChart.barMax = max;
        updateSliderHandlePosition(sliderGroup, sliderClass, id, 'max', scale(max));
        updateTrackInset(sliderGroup, scale, sliderClass, id, min, max);
        drawChart();
      }
    }

    function updateTrackInset(sliderGroup: any, scale: any, sliderClass: string, id: string, min: number, max: number): void {
      sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
        .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
        .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max));
    }

    function updateSliderHandlePosition(sliderGroup: any, sliderClass: string, id: string, handleType: string, newPos: number): void {
      sliderGroup.select(`.${sliderClass}.${id}-${handleType}-handle`)
        .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
      sliderGroup.select(`.${sliderClass}.${id}-${handleType}-hover-layer`)
        .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
    }

    function drawLegend(legendData: any) {

      const legendGroup = mySvg
        .select('#legendGroup' + myClass)
        .selectAll('.legendGroup' + myClass)
        .data(legendData)
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'legendGroup' + myClass);
          enter.append('circle').attr('class', 'legendCircle');
          enter.append('text').attr('class', 'legendLabel');
          return enter;
        });

      legendGroup.select('.legendCircle')
        .attr('id', (d: any) => 'circle_legendItem' + d)
        .attr('fill', (d: any) => myChart.props.barFill[d])
        .attr('r', 4);

      legendGroup.select('.legendLabel')
        .attr('id', (d: any) => 'legendItem' + d)
        .attr('y', 5)
        .attr('fill', myChart.props.legendColor || '#101D42')
        .attr('font-weight', '500')
        .attr('font-size', myChart.props.legendFontSize || 12)
        .attr('font-family', 'Poppins')
        .text((d: any) => myChart.props.barLabels[d].toUpperCase());

      let legendX = 0;
      mySvg.selectAll('.legendLabel').each(function (d: any): any {
        //@ts-ignore
        const myObject = this;
        const myWidth: any = document.getElementById(myObject.id)?.getBoundingClientRect().width;
        d3.select(myObject).attr('x', legendX + 12);
        mySvg.select('#circle_' + myObject.id).attr('cx', legendX);
        legendX += (40 + myWidth);
      });

      legendGroup.attr('transform', 'translate(' + ((width - legendX + 24) / 2) + ',10)');
      legendGroup.attr('visibility', myChart.props.legendShow ? 'visible' : 'hidden');
    }

    function getGroupLabel(d: any) {
      let myLabel = d.group.toUpperCase();
      while (!checkWidth(myLabel) || myLabel === "..") {
        if (myLabel.includes("..")) {
          myLabel = myLabel.substr(0, myLabel.length - 2);
        }
        myLabel = myLabel.substr(0, myLabel.length - 1) + "..";
      }
      return myLabel;
      function checkWidth(myText: any) {
        if ((measureWidth(myText, 12) + 4) > groupHeight) {
          return false;
        } else {
          return true;
        }
      }

    }
    function measureWidth(myText: any, myFontSize: any): any {
      const context: any = document.createElement('canvas').getContext('2d');
      context.font = myFontSize + 'px sans-serif';
      return context.measureText(myText).width;
    }

    // Defect counts are whole numbers, but on a short domain d3 picks a sub-unit step and
    // the SI format ('-2~s') then renders those ticks as milli units - "0 500m 1 1.5 2".
    // Fall back to a whole-number step in that case so the ticks read as counts.
    function xAxisTicks(scale: any): any[] {
      const tickCount = myChart.props.XtickCount;
      const ticks = scale.ticks(tickCount);
      if (ticks.every((t: any) => Number.isInteger(t))) {
        return ticks;
      }
      const [min, max] = scale.domain();
      const step = Math.max(1, Math.round((max - min) / tickCount));
      return d3.range(Math.ceil(min), Math.floor(max) + 1, step);
    }

    function renderXAxis(scale: any): void {
      mySvg.select('#xAxis' + myClass)
        .attr("visibility",
          myChart.props.xAxisShow && xMax !== 0 ? "visible" : "hidden"
        )
        .call(
          d3.axisBottom(scale)
            .tickSizeOuter(0)
            .tickValues(xAxisTicks(scale))
            .tickFormat((d: any) => axisTickFormat(myChart.props.xAxisFormatting)(d))
        )
        .attr('transform', 'translate(' + (width - chartWidth - margins.right) + ',' + (height - margins.bottom) + ')');

      mySvg.selectAll('#xAxis' + myClass + " text")
        .attr("font-family", "Poppins")
        .attr("font-weight", myChart.props.xAxisBold ? 700 : 400)
        .attr("font-size", myChart.props.xAxisFontSize)
        .attr("fill", myChart.props.xAxisColor);

      mySvg.select('#xAxis' + myClass + " path")
        .style('stroke-width', '1')
        .style('stroke', '#E8EAEE');

      mySvg.selectAll('#xAxis' + myClass + " line")
        .attr("y1", 0)
        .attr("y2", -(height - margins.top - margins.bottom))
        .style('stroke', '#E8EAEE')
        .style('stroke-width', '1');
    }

    function brushed(event: any): void {

      const selection = event.selection;
      if (selection !== null) {
        const yDomain: any = selection.map(yScaleAll.invert);
        if ((yDomain[1] - yDomain[0]) < 0.99) {
          if ((yDomain[0] + 1) > groupSet.length) {
            yDomain[0] = yDomain[1] - 1;
          } else {
            yDomain[1] = yDomain[0] + 1;
          }
          mySvg.select('#brushGroup' + myClass)
            .call(brush.move, myChart.props.showBrush === false ? null : [yScaleAll(yDomain[0]), yScaleAll(yDomain[1])]);
        } else {
          visibleGroups = ((yDomain[1] - yDomain[0]) / groupSet.length) * groupSet.length;
          yScale.domain(yDomain);

          drawChart();

          const handleSouthY = +mySvg.select('#brushGroup' + myClass).select('.handle--s').attr('y');
          const handleNorthY = +mySvg.select('#brushGroup' + myClass).select('.handle--n').attr('y');

          mySvg.select('.handleLeftLine1' + myClass)
            .attr('y1', handleSouthY + 3)
            .attr('y2', handleSouthY + 3);

          mySvg.select('.handleLeftLine2' + myClass)
            .attr('y1', handleSouthY + 7)
            .attr('y2', handleSouthY + 7);

          mySvg.select('.handleRightLine1' + myClass)
            .attr('y1', handleNorthY + 3)
            .attr('y2', handleNorthY + 3);

          mySvg.select('.handleRightLine2' + myClass)
            .attr('y1', handleNorthY + 7)
            .attr('y2', handleNorthY + 7);

          mySvg.select('#brushGroup' + myClass)
            .selectAll('.handle')
            .attr('fill', 'white')
            .attr('rx', 4)
            .attr('ry', 4)
            .attr('x', (margins.brush - 24) / 2)
            .attr('width', 24)
            .style('filter', 'url(#drop-shadow)');
        }
      }
    }

    this.stop(10).then(() => this.isLoading = false);
  }

  // property & data for the chart
  getGroupedHbarChartData() {
    this.GroupedHbarChartData = this.data;
    const cgf = this.item.config;

    this.props = {
      chartHeight: 500,
      rangeVar: 'range_nm',
      stackVar: 'error_type_code',
      groupVar: 'data_source_name',
      valueVar: 'defect_count',
      xAxisLabel: cgf?.['x_axis']?.["api_resp_column_display_nm"]?.toUpperCase() || 'DEFECT COUNT',
      yAxisLabel: cgf?.['y_axis']?.["api_resp_column_display_nm"]?.toUpperCase() || 'SOURCE NAME',
      barFill: { 'F': '#FF842B', 'E': '#FFD953' },
      barLabels: { 'F': 'Failures', 'E': 'Errors' },
      outlierMultiple: 4,
      leftSlider: cgf?.['zoom_slider_left']?.value == 'true' || false,
      totalOntop: cgf?.total_on_top?.value === 'true' || false,
      valueOnBar: cgf?.value_on_bar?.value === 'true' || false,
      valueOnBarType: cgf?.value_on_bar_type?.value || 'percentage',
      valueOnBarposition: cgf?.value_on_bar_position?.value || 'center',

      // Data label prefs
      valueOnBarColor: cgf?.value_on_bar_color?.value || 'white',
      valueOnBarBackground: cgf?.value_on_bar_background?.value === 'true' || false,
      valueOnBarBackgroundColor: cgf?.value_on_bar_background_color?.value || '#000000',
      valueOnBarDisplayUnits: cgf?.value_on_bar_display_units?.value || 'Auto',
      valueOnBardecimalPlaces: cgf?.value_on_bar_decimal_places?.value !== undefined
        ? parseInt(cgf?.value_on_bar_decimal_places?.value, 10)
        : 0,

      // Total label prefs
      totalOnTopColor: cgf?.total_on_top_color?.value || '#FFFFFF',
      totalOnTopBackground: cgf?.total_on_top_background?.value === 'true' || false,
      totalOnTopBackgroundColor: cgf?.total_on_top_background_color?.value || '#FFFFFF',
      displayUnits: cgf?.display_units?.value || 'Auto',
      decimalPlaces: cgf?.decimal_places?.value !== undefined
        ? parseInt(cgf?.decimal_places?.value, 10)
        : 0,

      // NEW: total label font defaults
      totalLabelFontSize: 12,
      totalLabelFont: 'Poppins',
      totalLabelBold: false,
      totalLabelColor: '#101D42',

      // X-Axis
      xAxisShow: true,
      xAxisFontSize: 12,
      xAxisBold: false,
      xAxisColor: '#101D42',
      XtickCount: 5,
      xAxisFormatting: '-2~s',

      // Y-Axis
      yAxisShow: true,
      yAxisFontSize: 12,
      yAxisBold: false,
      yAxisColor: '#101D42',

      // Legend
      legendShow: true,
      legendFontSize: 12,
      legendColor: '#101D42',
      legendPosition: 'top'
    };

    if (this.GroupedHbarChartData && this.GroupedHbarChartData.length > 0) {
      this.noData = true; 
      setTimeout(() => {
        if (this.prefrenceConfig) {
          this.applyChartPreferences(this.prefrenceConfig);
        } else {
          this.plotChart();
        }
      }, 100);
    } else {
      this.noDataNotifier.report('grouped-hbar-chart');
      this.isLoading = false;
      this.noData = false;
    }
  }

  // numberFormat
  numbedPipe(value: any) {
    return this.currency.transform(value, '', '', '1.0-2');
  }

  // NEW: same preference handler pattern as first H-bar component
  applyChartPreferences(event: any) {
    if (event) {
      // X-Axis
      this.props.xAxisShow = event.xAxis.show;
      this.props.xAxisFontSize = event.xAxis.fontSize;
      this.props.xAxisBold = event.xAxis.bold;
      this.props.xAxisColor = event.xAxis.color;

      // Y-Axis
      this.props.yAxisShow = event.yAxis.show;
      this.props.yAxisFontSize = event.yAxis.fontSize;
      this.props.yAxisBold = event.yAxis.bold;
      this.props.yAxisColor = event.yAxis.color;

      // Legend
      this.props.legendShow = event.legend.show;
      this.props.legendFontSize = event.legend.fontSize;
      this.props.legendColor = event.legend.color;
      this.props.legendPosition = event.legend.position;

      // Data Labels
      this.props.valueOnBar = event.dataLabels.enabled;
      this.props.valueOnBarColor = event.dataLabels.textColor;
      this.props.valueOnBarType = event.dataLabels.valueOnBarType;
      this.props.valueOnBarposition = event.dataLabels.position;
      this.props.valueOnBarBackground = event.dataLabels.background;
      this.props.valueOnBarBackgroundColor = event.dataLabels.backgroundColor;
      this.props.valueOnBarDisplayUnits = event.dataLabels.displayUnits;
      this.props.valueOnBardecimalPlaces = event.dataLabels.decimalPlaces;

      // Total Labels
      this.props.totalOntop = event.totalLabels.enabled;
      this.props.totalOnTopColor = event.totalLabels.color;
      this.props.totalOnTopBackground = event.totalLabels.background;
      this.props.totalOnTopBackgroundColor = event.totalLabels.backgroundColor;
      this.props.displayUnits = event.totalLabels.displayUnits;
      this.props.decimalPlaces = event.totalLabels.decimalPlaces;
      this.props.totalLabelFontSize = event.totalLabels.fontSize;
      this.props.totalLabelBold = event.totalLabels.bold;

      // Zoom Slider
      this.props.leftSlider = event.zoomSlider.show;
    }

    setTimeout(() => {
      this.plotChart();
    }, 50);
  }
}
